import { useState } from "react";
import {
  shortMonthFromDate,
  dayOfMonthFromDate,
  dayAndDateFromDate,
} from "src/utils";
import { EllipseVerticalIcon } from "src/assets/icons";
import {
  Container,
  IconContainer,
  IconHeader,
  IconBody,
  MainContainer,
  MainLabel,
  MainDate,
  UpdateIcon,
  EnterDateButton,
  NoDateContainer,
  NoDateLabel,
} from "./CalendarRow.styles";
import PopOut from "./PopOut";
import type { DateField } from "./PopOut/PopOut";
import { zeroDate } from "src/constants";

interface CalendarRowProps {
  colorStyle: "blue" | "tan";
  labelText: string;
  date: string | null;
  borderType?: "none" | "solid" | "dashed";
}

export default ({
  colorStyle,
  labelText,
  date,
  borderType = "solid",
}: CalendarRowProps) => {
  const [showPopOut, setShowPopout] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const field = labelText.toLowerCase().replace(/ /g, "_") as DateField;

  return (
    <Container borderType={borderType}>
      {!date || date === zeroDate ? (
        <NoDateContainer>
          <NoDateLabel>{labelText}</NoDateLabel>
          <EnterDateButton
            onClick={() => {
              setShowPopout(true);
              setShowCalendar(true);
            }}
          >
            Enter date
          </EnterDateButton>
        </NoDateContainer>
      ) : (
        <>
          <IconContainer>
            <IconHeader colorStyle={colorStyle}>
              {shortMonthFromDate(date)}
            </IconHeader>
            <IconBody>{dayOfMonthFromDate(date)}</IconBody>
          </IconContainer>
          <MainContainer>
            <MainLabel>{labelText}</MainLabel>
            <MainDate>{dayAndDateFromDate(date)}</MainDate>
          </MainContainer>
          <UpdateIcon
            onClick={() => {
              setShowCalendar(false);
              setShowPopout(true);
            }}
          >
            <EllipseVerticalIcon />
          </UpdateIcon>
        </>
      )}
      <PopOut
        isVisible={showPopOut}
        closeHandler={() => {
          setShowPopout(false);
          setShowCalendar(false);
        }}
        showCalendar={showCalendar}
        setShowCalendar={setShowCalendar}
        field={field}
      />
    </Container>
  );
};
